<template>
  <router-link v-slot="{ href, isActive, navigate }" :to="to" custom>
    <a
      v-tooltip="{ content: label, placement: tooltipPlacement }"
      :href="href"
      :aria-current="isActive || isChildMenuActive ? 'page' : null"
      class="relative flex items-center justify-center w-11 h-11 rounded-xl outline-none transition-colors duration-200 ease-out focus-visible:ring-2 focus-visible:ring-accent-mint/70 focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:focus-visible:ring-offset-ink"
      :class="
        isActive || isChildMenuActive
          ? 'bg-woot-25 text-accent-mint hover:bg-woot-50 dark:bg-mint/10 dark:hover:bg-mint/[0.16]'
          : 'text-slate-600 hover:bg-slate-50 hover:text-slate-800 dark:text-slate-300 dark:hover:bg-white/[0.06] dark:hover:text-slate-50'
      "
      :rel="openInNewPage ? 'noopener noreferrer nofollow' : undefined"
      :target="openInNewPage ? '_blank' : undefined"
      @click="navigate"
    >
      <!--
        The active rail. It lands flush on the column edge, not on the pill, so its offset is
        the rail's own gutter: 3.5 in the 4.5rem column, 1.5 in the 3.5rem one a phone gets.
        It grows out of the centre rather than fading in — the motion says "this is where you
        are", it does not decorate.
      -->
      <span
        aria-hidden="true"
        class="absolute inset-y-0 w-[3px] h-6 my-auto -start-1.5 md:-start-3.5 rounded-e-full bg-accent-mint transition-transform duration-200 ease-out"
        :class="isActive || isChildMenuActive ? 'scale-y-100' : 'scale-y-0'"
      />
      <fluent-icon :icon="icon" />
      <span class="sr-only">{{ label }}</span>
      <span
        v-if="count"
        class="absolute -top-0.5 -end-0.5 min-w-[1.125rem] px-1 leading-[1.125rem] text-center rounded-full text-xxs font-semibold bg-mint text-ink"
      >
        {{ count }}
      </span>
    </a>
  </router-link>
</template>
<script>
import rtlMixin from 'shared/mixins/rtlMixin';

export default {
  mixins: [rtlMixin],
  props: {
    to: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    count: {
      type: String,
      default: '',
    },
    isChildMenuActive: {
      type: Boolean,
      default: false,
    },
    openInNewPage: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    label() {
      return this.$t(`SIDEBAR.${this.name}`);
    },
    // The rail sits on the right of the screen in RTL, so a tooltip pinned to `right`
    // would open off-canvas. Placement is a JS option, not a class, so no logical
    // property can flip it for us.
    tooltipPlacement() {
      return this.isRTLView ? 'left' : 'right';
    },
  },
};
</script>
